(function() {
    'use strict';

    angular.module('user')
        .controller('ClientUpdateController', ClientUpdateController);

    ClientUpdateController.$inject = ['$state', 'clientDataSrvc', 'notificationSrvc', 'clientMessagesConst', 'errorNotificationSrvc'];

    function ClientUpdateController($state, clientDataSrvc, notificationSrvc, clientMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            user: {
                email: [],
                first_name: [],
                last_name: []
            },
            telephone: [],
            telephone_2: [],
            company_name: [],
            tax_id: [],
            address: [],
            building_number: [],
            suite_number: [],
            city: [],
            zip_code: [],
            country: [],
            company_name_2: [],
            address_2: [],
            building_number_2: [],
            suite_number_2: [],
            city_2: [],
            zip_code_2: [],
            main_account: [],
            non_field_errors: []
        };
        self.clientData = {
            limitation: {}
        };
        self.clientCompanyData = {};
        self.clientOptions = [];

        self.updateClient = updateClient;
        self.onClientSearch = onClientSearch;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getClient();
        }

        function getClient() {
            return clientDataSrvc.getFlattened({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.clientData = response;
                getClientOptions();
                return response;
            });
        }

        function getClientOptions() {
            return clientDataSrvc.getOptions({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    if (self.clientData.main_account) {
                        self.clientOptions = [{pk: self.clientData.main_account, full_name: self.clientData.main_account_name}].concat(response.results);
                    } else {
                        self.clientOptions = response.results;
                    }

                    return response;
                }
            );
        }

        function onClientSearch(params) {
            if (!params) {
                params = {};
            }
            params.pk = $state.params.pk;
            return clientDataSrvc.getOptions(
                params
            ).$promise;
        }

        function updateClient() {
            clientDataSrvc.update({
                pk: self.clientData.pk
            }, self.clientData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", clientMessagesConst.update);
                    $state.go('layout.client.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
